<template>
  <div class="history-card">
    <div class="card card-info mr-3" @click="handleDetail(idtraining)">
      <div class="card-bodyinf">
        <div class="d-flex-between">
          <div :class="'f-14 f-c-midgrey ' + status_css">
            {{ status_fix }}
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z"
                fill="#6F7287"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="sub-bodyinf pt-1 f-14">{{ idtraining }}</div>
      <div class="sub-bodyinftitle f-16 f-bold pt-1">
        {{ nama_program }}
      </div>
      <div class="countdown">
        <svg
          class="custom-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_1520_19609)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.00008 1.99996C4.68637 1.99996 2.00008 4.68625 2.00008 7.99996C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 7.99996C14.0001 4.68625 11.3138 1.99996 8.00008 1.99996ZM0.666748 7.99996C0.666748 3.94987 3.94999 0.666626 8.00008 0.666626C12.0502 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.05 0.666748 7.99996ZM7.99999 3.33329C8.36818 3.33329 8.66666 3.63177 8.66666 3.99996V7.58793L10.9648 8.73701C11.2941 8.90166 11.4276 9.30211 11.2629 9.63143C11.0983 9.96075 10.6978 10.0942 10.3685 9.92957L7.70185 8.59624C7.476 8.48331 7.33333 8.25247 7.33333 7.99996V3.99996C7.33333 3.63177 7.6318 3.33329 7.99999 3.33329Z"
              fill="#808080"
            />
          </g>
          <defs>
            <clipPath id="clip0_1520_19609">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span class="TimeInf p-l-8 f-12">{{
          $moment(timestart).format("DD MMMM YYYY HH:mm")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";
export default {
  name: "CardRiwayat",
  props: {
    status: "",
    nama_program: "",
    idtraining: "",
    timestart: "",
  },
  methods: {
    handleDetail(param_IdTraining) {
      this.$router.push({
        name: "detailTraining",
        params: { idtraining: param_IdTraining },
      });
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      riwayatTraining: "riwayatTraining",
    }),
    status_fix() {
      let text = this.status;
      let result = text.replace(/_/gi, " ");
      let parts = result.split(" ");
      let parts_slice = parts.slice(1);
      let capitalize = parts_slice.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
      let join = capitalize.join(" ");
      return `${join}`;
    },
    status_css() {
      let text = this.status;
      let result = text.replace("_", "");
      let cls_css = result.replace(/^.{2}/g, "");
      return `${cls_css}`;
    },
  },
};
</script>

<style>
.history-card {
  display: inline-flex;
  gap: 10px;
}
.history-card .card-bodyinf {
  background-color: white;
  padding-right: 10px;
  text-align: start;
}

.labelinf {
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
  margin-top: 2px;
  margin-bottom: 0;
  border-radius: 3px;
  background: var(--warning-yellow-light, #fff8e1);
  color: #6f7287;
  top: 10px;
  left: 10px;
}

.dibatalkan_oleh_cs {
  background-color: #da1e28;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
  color: #fff;
}
.dijadwalkan_ulang {
  background-color: #ffeddd;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
}
.terjadwalkan {
  background-color: #fceeff;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
}
.menunggu_konfirmasi_cs {
  background-color: #fff8e1;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
}
.menunggu_pembayaran {
  background-color: #e2f0ff;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
}

.selesai {
  background-color: #e2f0ff;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
}

.pembayaran_gagal {
  background-color: #fff1f1;
  padding: 3px;
  padding: 0px 4px;
  width: fit-content;
  border-radius: 3px;
}
</style>
